import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { contactInfo } from '../data';

export default function About() {
  return (
    <div className="bg-white">
      <SEO />

      {/* Hero Header */}
      <section className="relative py-24 bg-stone-900 text-white">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260707-214057.jpg" 
            alt="Tømrerarbejde af Munkgaard Træbyg" 
            className="w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-stone-900 via-stone-900/40 to-transparent" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-6 text-center flex flex-col gap-4">
          <span className="text-white font-semibold tracking-[0.2em] uppercase text-xs">
            Hvem er vi
          </span>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-white">
            Om os
          </h1>
          <p className="text-stone-300 text-lg max-w-2xl mx-auto">
            Tæt samarbejde og solidt håndværk – fra start til slut
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
          {/* Text Side */}
          <div className="lg:col-span-7 flex flex-col items-start gap-6">
            <h2 className="font-display text-3xl font-bold text-stone-900 leading-tight">
              Tæt samarbejde og solidt håndværk – fra start til slut
            </h2>
            <div className="text-stone-600 space-y-6 leading-relaxed">
              <p>
                Munkgaard Træbyg ApS er en mindre tømrervirksomhed med adresse på Kragelundvej 51, Kragelund ved Silkeborg. Vi udfører opgaver for kunder i Bording, Ikast, Engesvang, Silkeborg og omegn, men er ikke begrænsede – vi kører gerne efter de lidt større projekter i hele landsdelen. Firmaet ejes og drives af Jacob Munkgaard Sørensen, der har stor erfaring med klassisk tømrerarbejde og selvstændige byggeprojekter – store som små.
              </p>
              <p>
                Jacob brænder for gennemtænkte løsninger af høj kvalitet og den gode kundeservice. Vi er en nærværende virksomhed, og det er præcis dét, der gør os stærke: Når du vælger os, får du direkte kontakt med den person, der også står med værktøjet i hånden på din byggeplads. Det sikrer dig en tryg proces og et godt resultat – hver gang.
              </p>
              <p>
                Vi lægger stor vægt på grundig dialog fra start, så vi forstår dine ønsker og forventninger helt tydeligt. Det gør det lettere at levere den løsning, der passer bedst til netop dig – hvad enten det er nybyg, renovering, udhuse eller mindre tømreropgaver. Vi holder dig opdateret gennem hele forløbet og sørger for, at du føler dig tryg og inddraget undervejs.
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-4">
              <Link 
                to="/vores-styrker" 
                className="bg-accent hover:bg-accent-light text-white px-6 py-3 rounded-md text-sm font-semibold tracking-wide transition-all duration-300 hover:shadow-md"
              >
                Se vores styrker
              </Link>
              <Link 
                to="/kontakt" 
                className="border border-stone-300 hover:border-stone-400 text-stone-700 px-6 py-3 rounded-md text-sm font-semibold tracking-wide transition-all duration-300"
              >
                Kontakt os i dag
              </Link>
            </div>
          </div>

          {/* Image Side */}
          <div className="lg:col-span-5 grid grid-cols-2 gap-4">
            <div className="relative aspect-[3/4] rounded-xl overflow-hidden shadow-lg border border-stone-200/60 group">
              <img 
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260310-175448.jpg" 
                alt="Jacob Munkgaard Sørensen – Tømrermester og indehaver" 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-stone-950/80 via-stone-950/40 to-transparent p-4 text-white">
                <p className="text-xs font-semibold uppercase tracking-wider text-accent-light">Tømrermester</p>
                <p className="text-sm font-bold text-white">Jacob Munkgaard Sørensen</p>
              </div>
            </div>
            <div className="flex flex-col gap-4 mt-6">
              <div className="relative aspect-[4/3] rounded-xl overflow-hidden shadow-md border border-stone-200/60 group">
                <img 
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=500,quality=80,format=auto/assets/eb528839-41b2-4674-9198-41967ffbbdbc/fb-img-1675582914353_db7a75c8.jpg" 
                  alt="Jacob Munkgaard Sørensen på arbejde" 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="relative aspect-[4/3] rounded-xl overflow-hidden shadow-md border border-stone-200/60 group">
                <img 
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=500,quality=80,format=auto/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20250322064807.jpg" 
                  alt="Tømrerhåndværk af Munkgaard Træbyg" 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="py-24 bg-stone-50 border-t border-b border-stone-200">
        <div className="max-w-4xl mx-auto px-6 text-center flex flex-col gap-8">
          <h2 className="font-display text-3xl font-bold text-stone-900">
            Kontakt os og få tryghed hele vejen
          </h2>
          <p className="text-stone-600 leading-relaxed">
            Vi ved, hvor vigtigt det er med god kommunikation, når man som kunde lægger en byggeopgave i andres hænder. Derfor prioriterer vi tæt kontakt og løbende dialog, så du altid føler dig tryg og informeret. Vi mener, at den bedste oplevelse opstår, når kunden bliver en aktiv del af processen – og det sørger vi for.
          </p>
          <p className="text-stone-600 leading-relaxed">
            Kontakt Munkgaard Træbyg ApS i dag og lad os tage en uforpligtende snak om dine drømme og planer. Vi er klar til at hjælpe dig med din opgave.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-4">
            <a 
              href={`tel:${contactInfo.phoneRaw}`} 
              className="flex items-center gap-3 text-stone-800 hover:text-accent font-semibold text-lg transition-colors whitespace-nowrap"
            >
              <i className="fa-solid fa-phone text-accent" />
              {contactInfo.phone}
            </a>
            <a 
              href={`mailto:${contactInfo.email}`} 
              className="flex items-center gap-3 text-stone-800 hover:text-accent font-semibold text-lg transition-colors whitespace-nowrap"
            >
              <i className="fa-solid fa-envelope text-accent" />
              {contactInfo.email}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
